import axios from 'axios';

import getEnvironment from '../../../env-config/get-environment';

const s3Client = axios.create({
    baseURL: getEnvironment().efuneralMediaBucket,
});

export default s3Client;
